import axiosIns from '@/libs/axios'
import { objectToUrlParam } from '@/libs/helper'

export default class TicketsApis {
  getUnreadTickets = async () => await axiosIns.get('/ticketmodule/opens');

  getReadTickets = async data => await axiosIns.get(
    `/ticketmodule/closes?${objectToUrlParam(data)}`,
  )

  getTicketCategory = async () => await axiosIns.get('/ticketmodule/categories');

  createNewTicket = async data => {
    const formData = new FormData()
    Object.keys(data).forEach(element => {
      if (data[element]) {
        formData.append(element, data[element])
      }
    })
    return await axiosIns.post('/ticketmodule/create', formData)
  };

  sendTicketAnswer = async ({ id, answerTicket }) => {
    const formData = new FormData()
    Object.keys(answerTicket).forEach(element => {
      if (answerTicket[element]) {
        formData.append(element, answerTicket[element])
      }
    })
    return await axiosIns.post(`/ticketmodule/answer/${id}`, formData)
  };

  getTicketsById = async id => await axiosIns.get(`/ticketmodule/get/${id}`);

  closeTicketById = async id => await axiosIns.post(`/ticketmodule/close/${id}`);
}
